import { render, staticRenderFns } from "./ReferralPromotionUpdateForm.vue?vue&type=template&id=1f8d47d3&"
import script from "./ReferralPromotionUpdateForm.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8d47d3')) {
      api.createRecord('1f8d47d3', component.options)
    } else {
      api.reload('1f8d47d3', component.options)
    }
    module.hot.accept("./ReferralPromotionUpdateForm.vue?vue&type=template&id=1f8d47d3&", function () {
      api.rerender('1f8d47d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReferralPromotionUpdateForm.vue"
export default component.exports